// @flow
import { ALTER_VARIATION_FOR_ACTIVE_RECIPE } from './actionTypes'

export default (activeVariationId: string, stackTopObjectActiveVariationIndex) => ({
  type: ALTER_VARIATION_FOR_ACTIVE_RECIPE,
  payload: {
    activeVariationId,
    stackTopObjectActiveVariationIndex
  }
})